import { http, type HttpOptions } from './httpClient'
import type { Paginated, ProjectMember, ProjectRole } from './types'

export interface ProjectMemberListParams {
  limit?: number
  offset?: number
}

export interface AddProjectMemberRequest {
  email?: string
  user_id?: number
  role: ProjectRole
}

export interface UpdateProjectMemberRequest {
  role: ProjectRole
}

export const projectMemberApi = {
  list: (projectId: number, params?: ProjectMemberListParams) =>
    http.get<Paginated<ProjectMember>>(`/api/projects/${projectId}/members/`, { query: params }),

  add: (projectId: number, body: AddProjectMemberRequest, opts?: HttpOptions) =>
    http.post<ProjectMember, AddProjectMemberRequest>(
      `/api/projects/${projectId}/members/`,
      body,
      opts,
    ),

  update: (
    projectId: number,
    memberId: number,
    body: UpdateProjectMemberRequest,
    opts?: HttpOptions,
  ) =>
    http.patch<ProjectMember, UpdateProjectMemberRequest>(
      `/api/projects/${projectId}/members/${memberId}/`,
      body,
      opts,
    ),

  remove: (projectId: number, memberId: number, opts?: HttpOptions) =>
    http.delete<void>(`/api/projects/${projectId}/members/${memberId}/`, opts),

  makeOwner: (projectId: number, memberId: number, opts?: HttpOptions) =>
    http.post<ProjectMember, Record<string, never>>(
      `/api/projects/${projectId}/members/${memberId}/make-owner/`,
      {},
      opts,
    ),
}
